import { render, staticRenderFns } from "./ContratoProveedorPantalla.vue?vue&type=template&id=a113a8e0&"
import script from "./ContratoProveedorPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContratoProveedorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a113a8e0', component.options)
    } else {
      api.reload('a113a8e0', component.options)
    }
    module.hot.accept("./ContratoProveedorPantalla.vue?vue&type=template&id=a113a8e0&", function () {
      api.rerender('a113a8e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/ContratoProveedorPantalla.vue"
export default component.exports